export { default } from "./ResourcesPrimaryModule";
